import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("gf_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const fileUrl = (fileId) => {
  const token = localStorage.getItem("gf_token");
  return `${API}/files/${fileId}?auth=${token}`;
};

export const BRAND_KEY = "gf_branding";
export const cachedBranding = () => {
  try { return JSON.parse(localStorage.getItem(BRAND_KEY)) || null; } catch { return null; }
};
export const fetchBranding = async () => {
  try {
    const r = await fetch(`${API}/branding`);
    const d = await r.json();
    localStorage.setItem(BRAND_KEY, JSON.stringify(d));
    return d;
  } catch {
    return cachedBranding() || { app_name: "GudangFlow", has_logo: false };
  }
};
export const brandingLogoUrl = () => `${API}/branding/logo`;

// Base URL publik untuk link yang dibagikan (affiliate, QR) — pakai domain produksi tersimpan bila ada
export const publicBaseUrl = () => {
  const b = cachedBranding();
  return (b && b.app_url ? b.app_url : window.location.origin).replace(/\/$/, "");
};
